export const getDateRange = (dateFilter: string): { startDate: string; endDate: string } => {
    const today = new Date();
    let startDate = "";
    let endDate = "";

    const formatToUTC = (date: Date, endOfDay = false) => {
        if (endOfDay) {
            date.setUTCHours(23, 59, 59, 999);
        } else {
            date.setUTCHours(0, 0, 0, 0);
        }
        return date.toISOString();
    };

    switch (dateFilter) {
        case "Today":
            startDate = formatToUTC(new Date());
            endDate = formatToUTC(new Date(), true);
            break;

        case "This Week":
            const startOfWeek = new Date(today);
            startOfWeek.setDate(today.getDate() - today.getDay()); // Start of the week (Sunday)
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6); // End of the week (Saturday)

            startDate = formatToUTC(startOfWeek);
            endDate = formatToUTC(endOfWeek, true);
            break;

        case "Last Week":
            const startOfLastWeek = new Date(today);
            startOfLastWeek.setDate(today.getDate() - today.getDay() - 7);
            const endOfLastWeek = new Date(startOfLastWeek);
            endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);

            startDate = formatToUTC(startOfLastWeek);
            endDate = formatToUTC(endOfLastWeek, true);
            break;

        case "This Month":
            startDate = formatToUTC(new Date(today.getFullYear(), today.getMonth(), 1));
            endDate = formatToUTC(new Date(today.getFullYear(), today.getMonth() + 1, 0), true);
            break;

        case "Last Month":
            const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

            startDate = formatToUTC(startOfLastMonth);
            endDate = formatToUTC(endOfLastMonth, true);
            break;

        case "Last 3 Months":
            const startOf3MonthsAgo = new Date(today);
            startOf3MonthsAgo.setMonth(today.getMonth() - 3);

            startDate = formatToUTC(startOf3MonthsAgo);
            endDate = formatToUTC(new Date(), true);
            break;

        default:
            startDate = '';
            endDate = '';
    }

    return { startDate, endDate };
};

